import React, { useState } from "react";
import {
  ActionButton,
  BalanceText,
  Container,
  Text,
  TopUpAndWithDrawContainer,
  WalletContainer,
  WalletTitle,
  WalletDataContainer,
  ReloadIcon,
} from "./WalletCard.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import {
  BalanceLoading,
  PlusIconForTopUp,
  WithdrawIcon,
} from "@assets";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { TOPUP_LK } from "@constants";
import Lottie from "react-lottie";
import { api } from "@api";
import { localStorage } from '@utils';
import { Space } from "antd";

const WalletCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector(
    (state) => state.auth.user
  );
  const [loading, setLoading] = useState(false);

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`);
  };

  const goToTopUp = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const goToWithdraw = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  const checkExit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);
        })
        .catch(() => { });
    }
  }

  return (
    <Container>
      <WalletContainer onClick={goToWallet}>
        <WalletDataContainer>
          <Space>
            <WalletTitle> {t("wallet.walletTitle")} </WalletTitle>
            {can_exit_check && <ReloadIcon onClick={checkExit} />}
          </Space>
          <BalanceText>
            {is_in_game ? (
              <Lottie
                options={{
                  animationData: BalanceLoading,
                }}
                width={32}
                height={32}
              />
            ) : (
              `${getFormattedNumber(main_balance + bonus)} Ks`
            )}
          </BalanceText>
        </WalletDataContainer>
      </WalletContainer>

      <TopUpAndWithDrawContainer>
        <ActionButton onClick={goToTopUp}>
          <PlusIconForTopUp />
          <Text>{t("wallet.walletTopUp")}</Text>
        </ActionButton>

        <ActionButton onClick={goToWithdraw}>
          <WithdrawIcon />
          <Text>{t("wallet.walletWithdraw")}</Text>
        </ActionButton>
      </TopUpAndWithDrawContainer>
    </Container>
  );
};

export default WalletCard;
